/**
 * Utility mthod that generates table columns in the MUITable column format
 *
 * @param {object} columns
 */
export const getFormattedColumns = (columns, t) => {
  const formattedColumns = [];
  Object.keys(columns).map(columnKey => {
    const column = columns[columnKey];
    const muiColumn = {
      name: t ? t(columnKey) : columnKey,
      options: column.columnOptions
    };
    formattedColumns.push(muiColumn);
  });
  return formattedColumns;
};

/**
 * Utility method that generates table data in the MUITable data format
 *
 * @param {object} columns
 * @param {array} data
 * @param {object} options
 */
export const generateTableData = (columns, data, options = {}) => {
  const {
    emptyValueChar = ""
  } = options;
  const formattedData = [];
  data === null || data === void 0 ? void 0 : data.map((dataItem, index) => {
    const row = [];
    Object.keys(columns).map(columnKey => {
      const column = columns[columnKey];
      const value = column.fieldKey ? dataItem[column.fieldKey] : column.fieldExtractor(dataItem, index);
      row.push(value ? value : emptyValueChar);
    });
    row.push(index); //this should be used to retrieve the data when using actions

    formattedData.push(row);
  });
  return formattedData;
};